import { env } from '../config/env';
import Cookies from 'js-cookie';
import { useUser } from '../contexts/UserContext';
import { Loader2 } from 'lucide-react';
import { buildLoginRedirectUrl } from '../services/appUrls';
import { trackLoginStart } from '../services/analytics';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { userInfo, loading } = useUser();
  const authCookie = Cookies.get('uumail_ut');
  const mockAliasCount = new URLSearchParams(window.location.search).get('mockAliasCount') || localStorage.getItem('uumail_mock_alias_count');
  const allowDevMock = env.DEV && !!mockAliasCount;

  const redirectToLogin = () => {
    const currentUrl = window.location.href;
    const backendLoginUrl = buildLoginRedirectUrl(currentUrl);
    trackLoginStart();
    window.location.href = backendLoginUrl;
    return null;
  };

  if (!authCookie && !allowDevMock) {
    return redirectToLogin();
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!userInfo) {
    return redirectToLogin();
  }

  return <>{children}</>;
}

export default ProtectedRoute;
